import axios from './axios';

export default {
  shareEvent: async body => {
    const { data } = await axios.post(`/share/shared-event`, body);
    return data;
  }
};
